import { DataSourceLabel, ExtraId } from '@/common/apis/dtos';
import { Box, Divider } from '@mui/material';
import { useState } from 'react';
import { ExtraIdList } from './ExtraIdList';
import { TenantSelector } from './TenantSelector';

export interface ExtraIdDetailsProps {
  extraIds?: { [key: string]: ExtraId[] };
  dataSourceLabels?: { [key: string]: DataSourceLabel[] };
}

export const ExtraIdDetails = ({ extraIds, dataSourceLabels }: ExtraIdDetailsProps) => {
  const tenants = Object.keys(extraIds ?? {});
  const [selectedTenant, setSelectedTenant] = useState<string>(tenants[0] || '');
  
  if (!extraIds || Object.keys(extraIds).length === 0) {
    return null;
  }

  return (
    <Box className="extraid-details" data-testid="extra-id-details">
      <Divider sx={{ marginY: 2, borderBottomWidth: 2, borderColor: 'grey.200' }} />
      <TenantSelector
        tenants={tenants}
        selectedTenant={selectedTenant}
        onTenantChange={setSelectedTenant}
      />
      <ExtraIdList extraIds={extraIds} selectedTenant={selectedTenant} tenantDataSourceLabels={dataSourceLabels?.[selectedTenant]} />
    </Box>
  );
};
